import { normalizeCurrencyCode } from '@/src/helpers';
import { Token } from '@/src/models';
import { Flex, Text } from '@/src/ui-components';
import { TokenIcon } from '@/src/ui-components/token-icon';
import { TriangleAlert } from 'lucide-react';

type TokenBalanceProps = {
  className?: string;
  balance: string;
  token: Token | undefined;
};

export const TokenBalance = ({ balance, className, token }: TokenBalanceProps) => {
  if (!token) {
    return null;
  }

  return (
    <Flex align="center" justify="between" className={className}>
      <Flex align="center" gap="2">
        <TokenIcon
          src={token?.icon || '/placeholder-token.svg'}
          alt={token?.code || 'Token'}
          width={20}
          height={20}
          className="h-5 w-5 object-contain"
        />
        <Flex align="center" gap="2">
          <Text as="span">{token ? normalizeCurrencyCode(token?.code) : ''}</Text>
          {Number(balance) <= 0 && (
            <TriangleAlert
              style={{ color: '#ebab3c' }}
              size={16}
              strokeWidth={1.5}
              absoluteStrokeWidth={true}
            />
          )}
        </Flex>
      </Flex>

      <Text as="span" weight="medium" className="font-mono">
        {Number(balance).toFixed(2)}
      </Text>
    </Flex>
  );
};
